import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import ImageDemo from './ImageDemo'
import ImageEditorActions from './ImageEditorActions'
import ImageElement from './ImageElement'
import ImageFormBrand from './ImageFormBrand'
import { STYLE_FORM_SCHEMA } from './ImageFormStyle'
import ImageFormValue from './ImageFormValue'
import imageIcon from './assets/image.svg'

export default genElementConfig(CONFIG_ELEMENTS.image, {
  label: t('elements.image.label'),
  group: ElementGroup.view,
  icon: imageIcon,
  styleFields: STYLE_FORM_SCHEMA,
  Element: ImageElement,
  Demo: [ImageDemo],
  FormBrand: ImageFormBrand,
  FormValue: ImageFormValue,
  EditorActions: ImageEditorActions,
})
